import React from 'react';

interface IProps {
  className?: string;
}

const MessageQuestionFilledIcon: React.FC<IProps> = ({ className = 'size-4' }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 1.21509H3.5C2 1.21509 1 2.21509 1 3.71509V6.71509C1 8.21509 2 9.21509 3.5 9.21509V10.2801C3.5 10.6801 3.945 10.9201 4.275 10.6951L6.5 9.21509H8.5C10 9.21509 11 8.21509 11 6.71509V3.71509C11 2.21509 10 1.21509 8.5 1.21509ZM6 7.30009C5.79 7.30009 5.625 7.13009 5.625 6.92509C5.625 6.72009 5.79 6.55009 6 6.55009C6.21 6.55009 6.375 6.72009 6.375 6.92509C6.375 7.13009 6.21 7.30009 6 7.30009ZM6.63 5.22509C6.435 5.35509 6.375 5.44009 6.375 5.58009V5.68509C6.375 5.89009 6.205 6.06009 6 6.06009C5.795 6.06009 5.625 5.89009 5.625 5.68509V5.58009C5.625 5.00009 6.05 4.71509 6.21 4.60509C6.395 4.48009 6.455 4.39509 6.455 4.26509C6.455 4.01509 6.25 3.81009 6 3.81009C5.75 3.81009 5.545 4.01509 5.545 4.26509C5.545 4.47009 5.375 4.64009 5.17 4.64009C4.965 4.64009 4.795 4.47009 4.795 4.26509C4.795 3.60009 5.335 3.06009 6 3.06009C6.665 3.06009 7.205 3.60009 7.205 4.26509C7.205 4.83509 6.785 5.12009 6.63 5.22509Z"
      fill="currentColor"
    />
  </svg>
);

export default MessageQuestionFilledIcon;
